import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import "./StudentResponses.scss";
import Multiselect from "multiselect-react-dropdown";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { AssessmentName } from "../Student/Reusablecomponents/RegularFunctions";
import InternetChecking from "../Student/Reusablecomponents/Network";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { Row, Col } from "react-bootstrap";
import notify from "../ReusableComponents/ToastifyAlerts";
import {
  GetAssessmentsNames,
  GetANamesInStitutes,
  Society,
  GetAssDateGrades,
  GetStationorCantonmentNames,
} from "../ReusableComponents/NCLAdminDropdowns";
import axiosInstance from "../ReusableComponents/Axios";
import { LoadContext } from "../ReusableComponents/LoadingContex";
import { useSelector } from "react-redux";
const DownloadStudentResponses = () => {
  const GradeRef = useRef();
  const { SetLoad, Load } = useContext(LoadContext);

  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const [SelecTest, SetSelecTest] = useState();
  const [SelectSubject, SetSelectSubject] = useState([]);
  const [SGrade, SetSGrade] = useState([]);

  const [SelectINID, SetSelectINID] = useState();
  const [RSOptions, SetRSOptions] = useState();
  const [SRSData, SetSRSData] = useState();
  const [ScoietyData, SetScoietyData] = useState();
  const [AssDates, SetAssDates] = useState();
  const [StationId, SetStationId] = useState();
  const GetRSDetails = async (INID, LType) => {
    try {
      const res = await axiosInstance.get(
        `/CommonAPI/GetRegionsOrStateslist?InstituteId=${INID}&ListType=${LType}`,
      );
      const RSDetails = res.data.map((item) => ({
        display: item.values,
        value: item.id,
      }));
      SetRSOptions([...RSDetails, { display: "All", value: 0 }]);
      SetSRSData(RSDetails[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const SheetDownload = async (data) => {
    const workbook = new ExcelJS.Workbook();
    data.forEach((Responce, index) => {
      const worksheetData = [
        [...Object.keys(Responce.SheetDetails[0]).map((key) => key)],
        ...Responce.SheetDetails.map((item, index) => [
          ...Object.keys(item).map((key, i) => item[key]),
        ]),
      ];
      const worksheet = workbook.addWorksheet(Responce.SheetName);
      worksheet.views = [{ state: "frozen", ySplit: 2 }];
      worksheet.mergeCells(
        1,
        1,
        1,
        Object.keys(Responce.SheetDetails[0]).length,
      );
      worksheet.getCell(1, 1).value = `${SelectINID?.Code
        } - Student Responses Data Sheet - ${AssDates?.display
        } - ${AssessmentName(AssDates?.assessmentType)}`;
      worksheet.getCell("A1").alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 30;
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "95b3d7" },
        };
      });
      worksheet.autoFilter = {
        from: { row: 2, column: 1 },
        to: { row: 2, column: Object.keys(Responce.SheetDetails[0]).length },
      };

      worksheet.columns = worksheetData[0].map(() => ({ width: 23 }));
      worksheetData.forEach((data, index) => {
        const row = worksheet.addRow(data);
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center", vertical: "middle" };
          if (cell.value && cell.value.length > 15) {
            cell.alignment = { wrapText: true, vertical: "middle" };
          }
        });
      });

      worksheet.getRow(2).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "d9e1f2" },
        };
      });
      worksheet.getRow(2).font = { bold: true };

      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // saveAs(
    //   blob,
    //   // `StudentResponses_${SelectINID?.Code}_${AssDates?.display}`
    //   `${SelecTest?.display}_${SelectINID?.Code}_${SRSData?.display}_${SGrade}_${AssDates?.display}.xlsx`
    // );
    if (SelectINID?.value === 1 || SelectINID?.value === 3) {
      saveAs(
        blob,
        `${SelecTest?.display}_${SelectINID?.Code}_${SRSData?.display}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    } else if (
      SelectINID?.value === 8 ||
      SelectINID?.value === 9 ||
      SelectINID?.value === 5
    ) {
      saveAs(
        blob,
        `${SelecTest?.display}_${ScoietyData?.display}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    } else {
      saveAs(
        blob,
        `${SelecTest?.display}_${SelectINID?.Code}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    }
    SetLoad((prev) => !prev);
  };
  const DownloadReport = async () => {
    if (SelectSubject.length > 0 && SGrade.length > 0) {
      SetLoad((prev) => !prev);
      const GS = SGrade?.length > 1 ? "grade" : "subjectName";
      try {
        const res = await axiosInstance.get(
          `/NCLAdmin/GetStudentAssessmentResponseByMultipleGradeAndSubject?ContestCreationId=${AssDates?.value}&SubjectName=${SelectSubject.join(",")}&InstituteId=${SelectINID?.value}&AssessmentType=${AssDates?.assessmentType}&Grade=${SGrade?.join(
            ",",
          )}&RegionId=${SelectINID?.value === 1 || SelectINID?.value === 3 ? SRSData?.value : 0}&StateId=${SelectINID?.value === 1 || SelectINID?.value === 3
            ? 0
            : SRSData?.value
          }&SocietyId=${ScoietyData?.value || 0}`,
        );
        if (res.data[0]?.[GS]) {
          const data = res.data.reduce((acc, student, index) => {
            const grade = student[GS];
            let gradeObj = acc.find(
              (item) =>
                item.SheetName ===
                (SGrade?.length > 1 ? `Grade ${grade}` : grade),
            );
            if (!gradeObj) {
              gradeObj = {
                SheetName: SGrade?.length > 1 ? `Grade ${grade}` : grade,
                SheetDetails: [],
              };
              acc.push(gradeObj);
            }

            const questions = [];
            for (
              let i = 1;
              i <=
              Object.keys(student).filter((key) => key.startsWith("qId"))
                .length;
              i++
            ) {
              questions.push({
                [`Q${i}_ID`]: student[`qId_${i}`],
                [`Q${i}_difficulty_level`]: student[`dL_${i}`],
                [`Q${i}_question_type`]: student[`qType_${i}`],
                [`Q${i}_key`]: student[`key_${i}`].replace(/<\/?p>/g, ""),
                [`Q${i}_LO`]: student[`lO_${i}`],
                [`Q${i}_credit`]: student[`q${i}_Credits`],
                [`Q${i}_response_marked`]: student[`q${i}_Response_marked`],
              });
            }
            const studentData = {
              "S.No": gradeObj.SheetDetails.length + 1,
              Instiute: SelectINID?.Code,
              [SelectINID?.value === 1 || SelectINID?.value === 3
                ? "Region"
                : "State"]:
                SelectINID?.value === 1 || SelectINID?.value === 3
                  ? student.regionName
                  : student.stateName,
              District: student.districtName,
              SchoolName: student.schoolName,
              "Student LoginId": student.loginId,
              Grade: student.grade,
              ...(ScoietyData?.display === "NATCO" && {
                PSTStatus: student.pstStatus,
              }),
              Gender: student.gender,
              "Assessment Date": student.testStartTime,
              "Time on subject mins": student.timeInMin,
              "Total time on assesment mins": student.totalTime,
              Subject: student.subjectName,
              ...Object.assign({}, ...questions),
            };
            gradeObj.SheetDetails.push(studentData);
            return acc;
          }, []);
          SheetDownload(data);
        } else {
          notify("No data found. Please select another option", "error");
          SetLoad((prev) => !prev);
        }
      } catch (err) {
        notify("No data found. Please select another option", "error");
        SetLoad((prev) => !prev);
      }
    } else {
      notify(
        `Please select ${SGrade.length === 0 ? "Grade" : "Subject"}`,
        "warning",
      );
    }
  };

  const GradeOptions = (e) => {
    SetSGrade([e]);
    //   SetSGrade(
    //   e.includes("All")
    //     ? ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
    //     : [...e]
    // );
    RenderSubjects([e]);
  };

  const SubjectOptions = (e) => {
    SetSelectSubject(
      e.includes("All")
        ? [
          "English",
          "Mathematics",
          "Science",
          "Biology",
          "BioTechnology",
          "Physics and Chemistry",
        ]
        : [...e],
    );
  };
  useEffect(() => {
    if (SelectINID?.value) {
      if (SelectINID?.value === 1 || SelectINID?.value === 3) {
        GetRSDetails(SelectINID?.value, "R");
      } else {
        GetRSDetails(SelectINID?.value, "S");
      }
    }
  }, [SelectINID?.value]);

  const RenderSubjects = async (SG) => {
    SetSelectSubject([]);
    const Grade = JSON.parse(SG);

    // const hasBelowOrEqual10 = SG.some((value) => value <= 10);
    // const hasAbove10 = SG.some((value) => value > 10);
    // switch (true) {
    //   // case hasBelowOrEqual10 && hasAbove10:
    //   //   SetSelectSubject([
    //   //     "English",
    //   //     "Mathematics",
    //   //     "Science",
    //   //     "Biology",
    //   //     "BioTechnology",
    //   //     "Physics and Chemistry",
    //   //   ]);
    //   //   break;
    //   case hasBelowOrEqual10:
    //     SetSelectSubject(["English", "Mathematics", "Science"]);
    //     break;
    //   case hasAbove10:
    //     SetSelectSubject([
    //       "English",
    //       "Mathematics",
    //       "Biology",
    //       "BioTechnology",
    //       "Physics and Chemistry",
    //     ]);
    //     break;
    // }
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetResponceAssessmentSubjects?ContestcreationId=${AssDates?.value}&Grade=${Grade}&AssessmentTypeId=${AssDates?.assessmentType}`);
      const Foramtdata = res.data.map((Sub) => Sub.subjectName)
      SetSelectSubject(Foramtdata);
    }
    catch (err) { console.log(err) }
  };
  useMemo(() => {
    if (AssDates?.value) {
      SetSGrade([AssDates?.grade.split(",")[0]]);
      RenderSubjects([AssDates?.grade.split(",")[0]]);
      // SetSelectSubject([]);
      // GradeRef.current.resetSelectedValues();
    }
  }, [AssDates]);
  const HandleDownloadreport = () => {
    if (SelectSubject.length > 0 && SGrade.length > 0) {
      if (AssDates?.assessmentType !== 3) {
        DownloadReport();
      } else if (AssDates?.assessmentType === 3) {
        DownloadSamagra();
      }
    } else {
      notify(
        `Please select ${SGrade.length === 0 ? "Grade" : "Subject"}`,
        "warning",
      );
    }
  };

  const DownloadSamagra = async () => {
    SetLoad((prev) => !prev);
    try {
      const res =
        await axiosInstance.get(`/NCLAdmin/ReportsGetSamagraStudentsResponses?ContestCreationId=${AssDates?.value}&SubjectName=${SelectSubject.join(",")}&InstituteId=${SelectINID?.value}&AssessmentType=3&Grade=${SGrade?.join(",")}
&RegionId=${SelectINID?.value === 1 || SelectINID?.value === 3 ? SRSData?.value : 0}&StateId=${SelectINID?.value === 1 || SelectINID?.value === 3
            ? 0
            : SRSData?.value
          }&SocietyId=${ScoietyData?.value || 0}`);

      const QDetails = res.data
        .filter((item) => item?.sets === "Set2")
        // .sort((a, b) => a.questionGrade - b.questionGrade)
        .map((Qitem) => ({
          questionId: Qitem?.questionId,
          questionGrade: Qitem?.questionGrade,
          lo: Qitem?.lo,
          Grade: Qitem.grade,
          Subject: Qitem.subjectName,
        }));
      const GS = SGrade?.length > 1 ? "grade" : "subjectName";
      const SDetails = res.data.filter((item) => item?.sets === "Set1");

      if (SDetails.length > 0) {
        const data = SDetails.reduce((acc, student, index) => {
          const grade = student[GS];
          let gradeObj = acc.find(
            (item) =>
              item.SheetName ===
              (SGrade?.length > 1 ? `Grade ${grade}` : grade),
          );
          if (!gradeObj) {
            gradeObj = {
              SheetName: SGrade?.length > 1 ? `Grade ${grade}` : grade,
              SheetDetails: [],
            };
            acc.push(gradeObj);
          }
          const questions = [];
          for (let i = 1; i <= student.noOfQuestion; i++) {
            questions.push({
              [`q${i}_Credits`]: student[`q${i}_Credits`],
            });
          }
          const studentData = {
            "S.No": gradeObj.SheetDetails.length + 1,
            schoolName: student.schoolName,
            District: student.district,
            loginId: student.loginId,
            firstName: student.firstName,
            lastName: student.lastName,
            Grade: student.grade,
            ...(ScoietyData?.display === "NATCO" && {
              PSTStatus: student.pstStatus,
            }),
            Subject: student.subjectName,
            schoolId: student.schoolId,
            ...Object.assign({}, ...questions),
          };
          gradeObj.SheetDetails.push(studentData);
          return acc;
        }, []);

        SamagraSheetDownload(QDetails, data);
      } else {
        notify("No data found. Please select another option", "error");
        SetLoad((prev) => !prev);
      }
    } catch (err) {
      SetLoad((prev) => !prev);
    }
  };
  const SamagraSheetDownload = async (QDetails, ResponceList) => {
    const GS = SGrade?.length > 1 ? "Grade" : "Subject";
    const emptyColumns = Array(ScoietyData?.display === "NATCO" ? 8 : 7).fill("");
    const workbook = new ExcelJS.Workbook();
    ResponceList.forEach((Responce, index) => {
      const worksheetData = [
        [
          "S.No",
          "SchoolId",
          "SchoolName",
          "District",
          "LoginId",
          "FirstName",
          "LastName",
          ...(ScoietyData?.display === "NATCO" ? ["PST Status"] : []),
          ...QDetails?.filter(
            (item) => item[GS] === Responce?.SheetName,
          )?.flatMap((item, index) => [`Q${index + 1}`]),
        ],

        [
          ...emptyColumns,
          ...QDetails?.filter(
            (item) => item[GS] === Responce?.SheetName,
          )?.flatMap((item) => [item.questionId]),
        ],
        [
          ...emptyColumns,
          ...QDetails?.filter(
            (item) => item[GS] === Responce?.SheetName,
          )?.flatMap((item) => [
            item?.questionGrade === "0" ? "Pre-primary" : item?.questionGrade,
          ]),
        ],
        [
          ...emptyColumns,
          ...QDetails?.filter(
            (item) => item[GS] === Responce?.SheetName,
          )?.flatMap((item) => [item?.lo]),
        ],
        ...Responce?.SheetDetails?.map((item) => [
          item?.[`S.No`],
          item?.schoolId,
          item?.schoolName,
          item?.District,
          item?.loginId,
          item?.firstName,
          item?.lastName,
          ...(ScoietyData?.display === "NATCO"
            ? [item?.PSTStatus]
            : []),
          ...QDetails?.map((_, index) => item[`q${index + 1}_Credits`]),
        ]),
      ];
      const worksheet = workbook.addWorksheet(
        `Grade - ${Responce.SheetDetails[0].Grade} - ${Responce.SheetDetails[0].Subject}`,
      );
      // worksheet.views = [{ state: "frozen", ySplit: 8 }];
      worksheet.mergeCells(
        1,
        1,
        1,
        Object.keys(Responce.SheetDetails[0]).length - 2,
      );
      worksheet.getCell(1, 1).value =
        `${SelectINID?.Code} - Student Responses Data Sheet - ${AssDates?.display} -  ${AssessmentName(AssDates?.assessmentType)}`;
      worksheet.getCell("A1").alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 30;
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "95b3d7" },
        };
      });
      // worksheet.autoFilter = {
      //   from: "A8",
      //   to: `${String.fromCharCode(
      //     64 +
      //     Object.keys(Responce.SheetDetails[0]).filter(
      //       (key) => !key.startsWith("Q")
      //     ).length
      //   )}8`,
      // };
      if (worksheet.length > 0) {
        const filterRange = {
          from: `${worksheet[0]}1`,
          to: `${worksheet[worksheet.length - 1]}1`,
        };
        worksheet.autoFilter = filterRange;
      }
      worksheet.columns = worksheetData[0].map(() => ({ width: 20 }));
      worksheetData.forEach((data, index) => {
        const row = worksheet.addRow(data);
        // if (index < 5 || index === 6) {
        //   questionHeaders.map((_, i) => {
        //     worksheet.mergeCells(
        //       index + 2,
        //       emptyColumns.length + i + 2 + i,
        //       index + 2,
        //       emptyColumns.length + i + 3 + i
        //     );
        //   });
        // }

        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center", vertical: "middle" };
          if (cell.value && cell.value.length > 15) {
            cell.alignment = { wrapText: true, vertical: "middle" };
          }
        });
      });

      // worksheetData.forEach((data, index) => {
      //   // if (index < 10) {
      //   //   worksheet.mergeCells(3, index + 1, 9, index + 1);
      //   // }
      //   if (index < 7) {
      //     worksheet.getRow(index + 2).eachCell((cell) => {
      //       cell.fill = {
      //         type: "pattern",
      //         pattern: "solid",
      //         fgColor: { argb: "d9e1f2" },
      //       };
      //     });
      //   }
      // });
      worksheet.getRow(2).font = { bold: true };
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // saveAs(
    //   blob,
    //   `StudentResponses_${SelectINID?.Code}_${AssDates?.display}.xlsx`
    // );
    if (SelectINID?.value === 1 || SelectINID?.value === 3) {
      saveAs(
        blob,
        `${SelecTest?.display}_${SelectINID?.Code}_${SRSData?.display}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    } else if (
      SelectINID?.value === 8 ||
      SelectINID?.value === 9 ||
      SelectINID?.value === 5
    ) {
      saveAs(
        blob,
        `${SelecTest?.display}_${ScoietyData?.display}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    } else {
      saveAs(
        blob,
        `${SelecTest?.display}_${SelectINID?.Code}_${SGrade}_${AssDates?.display}.xlsx`,
      );
    }
    SetLoad((prev) => !prev);
    notify("Student Responses sheet downloaded successfully", "success");
  };

  // const DDownload = () => {
  //   if (SGrade.length > 0) {
  //     const a = document.createElement("a");
  //     // a.style.display = 'none';
  //     if (SelectINID?.value === 8 || SelectINID?.value === 9 || SelectINID?.value === 5) {
  //       a.href = `/ExportStudents/${USYear?.display}/${SelecTest?.display}/${SelecTest?.display}_${ScoietyData?.display}_${SGrade}_${AssDates?.display}.xlsx`;
  //     } else {
  //       a.href = `/ExportStudents/${USYear?.display}/${SelecTest?.display}/${SelecTest?.display}_${SelectINID?.Code}_${SGrade}_${AssDates?.display}.xlsx`;
  //     }
  //     a.download = `StudentResponses_${SelectINID?.Code}_${AssDates?.display}.xlsx`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //   } else {
  //     notify("Please select Grade", "warning");
  //   }
  // }
  const DDownload = async () => {
    if (SGrade.length === 0) {
      notify("Please select Grade", "warning");
      return;
    }

    let filePath = "";
    if (SelectINID?.value === 1 || SelectINID?.value === 3) {
      filePath = `/ExportStudents/${USYear?.display}/${SelecTest?.display}/${SelecTest?.display}_${SelectINID?.Code}_${SRSData?.display}_${SGrade}_${AssDates?.display}.xlsx`;
    } else if (
      SelectINID?.value === 8 ||
      SelectINID?.value === 9 ||
      SelectINID?.value === 5
    ) {
      filePath = `/ExportStudents/${USYear?.display}/${SelecTest?.display}/${SelecTest?.display}_${ScoietyData?.display}_${SGrade}_${AssDates?.display}.xlsx`;
    } else {
      filePath = `/ExportStudents/${USYear?.display}/${SelecTest?.display}/${SelecTest?.display}_${SelectINID?.Code}_${SGrade}_${AssDates?.display}.xlsx`;
    }

    try {
      const response = await fetch(filePath);
      const contentType = response.headers.get("content-type");
      // ❗ If React fallback happened
      if (!contentType || contentType.includes("text/html")) {
        notify("File not found in location", "warning");
        return;
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filePath.split("/").pop();
      // `StudentResponses_${SelectINID?.Code}_${AssDates?.display}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      notify("File Downloaded successfully", "success");
      try {
        const payload = {
          userTypeId: items?.userTypeId || 0,
          userId: items?.userId || 0,
          reportType: "Student Responses",
          contestCreationId: AssDates?.value || 0,
          assessmentTypeId: AssDates?.assessmentType || 0,
          instituteId: SelectINID?.value || 0,
        };

        await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);
      } catch (error) {
        console.error("Error logging report download:", error);
      }

    } catch (error) {
      notify("File not available", "error");
    }
  };

  const HandleRSChange = (e) => {
    const selectedOption = RSOptions.find((opt) => opt.value === Number(e));
    if (selectedOption) {
      SetSRSData(selectedOption);
    }
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="MainHeading">
          {" "}
          Export Student responses data generation
        </div>

        <div className="container-fluid mt-4 InputFIlters">
          <label>Input</label>
          <br />
          <Row>
            <Col>
              <GetAssessmentsNames GetAll={true}
                className="NCLDropdown w-100"
                SOption={SelecTest?.value}
                onChange={(e) => SetSelecTest(e)}
                StoreValue={SetSelecTest}
                labelname={
                  <div className="DropdownHeader">Assessment No :</div>
                }
              />
            </Col>
            <Col>
              <GetANamesInStitutes
                className="NCLDropdown w-100"
                labelname={<div className="DropdownHeader">Institute :</div>}
                ATypeNO={SelecTest?.value}
                StoreValue={SetSelectINID}
                SOption={SelectINID?.value}
                ClearValue={SetScoietyData}
              />
            </Col>
            {SelectINID?.value && (
              <Col>
                <DropdownValues
                  className="NCLDropdown w-100"
                  options={RSOptions}
                  selectoption={SRSData?.value}
                  onChange={(e) => {
                    HandleRSChange(e.target.value);
                  }}
                  labelname={
                    <div className="DropdownHeader">
                      {SelectINID?.value === 1 ||
                        SelectINID?.value === 3 ||
                        SelectINID?.value === 6
                        ? "Region"
                        : "State"}{" "}
                      :
                    </div>
                  }
                />
              </Col>
            )}
            {(SelectINID?.value === 8 ||
              SelectINID?.value === 9 ||
              SelectINID?.value === 5) && (
                <Col>
                  <Society
                    className="NCLDropdown w-100"
                    labelname={<div className="DropdownHeader">Society :</div>}
                    PId={SelectINID?.value}
                    SOption={ScoietyData?.value}
                    StoreValue={SetScoietyData}
                    onChange={(e) => {
                      SetScoietyData(e);
                    }}
                  />
                </Col>
              )}
            {/* {(SelectINID?.Value === 6) && (
              <Col>
                <GetStationorCantonmentNames
                  className="NCLDropdown w-100"
                  StoreValue={SetStationId}
                  onChange={(e) => {
                    SetStationId(e);
                  }}
                  labelname={
                    <div className="DropdownHeader">Station /Cantonment</div>
                  }
                />
              </Col>
            )} */}
            <Col>
              {/* {AssDates?.display}==== */}
              <GetAssDateGrades
                className="NCLDropdown w-100"
                ATypeNO={SelecTest?.value}
                InstID={SelectINID?.value}
                Scoiety={ScoietyData?.value}
                SOption={AssDates?.value}
                StoreValue={SetAssDates}
                labelname={
                  <div className="DropdownHeader">Assessment Date :</div>
                }
              />
            </Col>
            <Col>
              <div className="LabelName">
                Grade :
                <Multiselect
                  ref={GradeRef}
                  isObject={false}
                  className="dropdown-checkbox mt-1 "
                  selectedValues={SGrade}
                  onRemove={(e, r) => GradeOptions(e, r)}
                  style={{ color: "black" }}
                  // style={(SelectSubject?.length <= 1 && Number(AssDates?.assessmentType) !== 3) ? { searchBox: { minHeight: "15vh", }, } : {}}
                  onSearch={function noRefCheck() { }}
                  placeholder=""
                  singleSelect="true"
                  // singleSelect={SelectSubject?.length > 1 || AssDates?.assessmentType === 3}
                  avoidHighlightFirstOption="true"
                  disablePreSelectedValues="true"
                  onSelect={(e, r) => GradeOptions(e, r)}
                  options={AssDates?.grade.split(",").map((g) => g.trim())}
                  showCheckbox
                />
              </div>
            </Col>
            <Col>
              <div className="LabelName">
                Subject :
                <ul
                  className=""
                  style={{
                    border: "2px solid #cbcbcb",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    minHeight: "38px",
                    padding: "5px 10px",
                    listStyle: "none",
                  }}
                >
                  {SelectSubject.map((sub) => (
                    <li>{sub}</li>
                  ))}
                </ul>
              </div>
            </Col>
           
          </Row>
          <div className="dflex" style={{ justifyContent: "end" }}>
            <button
              className={`Buttons m-3 ${Load && "DisableButton"}`}
              disabled={Load}
              onClick={() => {
                DDownload();
              }}
              // onClick={() => { !Load && HandleDownloadreport(); }}
            >
              Download{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default DownloadStudentResponses;
